// extracted by mini-css-extract-plugin
module.exports = {"container":"WebhookEndpointDetailsContextualView_container__21Yrx","closeImage":"WebhookEndpointDetailsContextualView_closeImage__2rY0H"};